import { gql } from '@apollo/client';

export const EMAIL_LOGS_LIST = gql`
  query EmailLogsList {
    emailLogsList {
      items {
        id
        fromEmail
        toEmail
        subject
        sentAt
        status
        messageId
        template {
          id
          name
          category
        }
        oAuthConfig {
          id
          provider
        }
      }
    }
  }
`;

export const EMAIL_LOGS_BY_REQUEST = gql`
  query EmailLogsByRequest($relatedRecord: String!) {
    emailLogsList(filter: { relatedRecord: { equals: $relatedRecord } }) {
      items {
        id
        fromEmail
        toEmail
        subject
        sentAt
        status
        messageId
        template {
          id
          name
          category
        }
        oAuthConfig {
          id
          provider
        }
      }
    }
  }
`;

export const EMAIL_LOG_GET = gql`
  query EmailLogGet($id: ID!) {
    emailLog(id: $id) {
      id
      fromEmail
      toEmail
      subject
      body
      sentAt
      status
      messageId
      errorMessage
      retryCount
      relatedRecord
      template {
        id
        name
        category
      }
      oAuthConfig {
        id
        provider
      }
    }
  }
`;

export const EMAIL_LOG_CREATE = gql`
  mutation EmailLogCreate($data: EmailLogCreateInput!) {
    emailLogCreate(data: $data) {
      id
      toEmail
      subject
      sentAt
      status
    }
  }
`;

export const EMAIL_LOG_UPDATE = gql`
  mutation EmailLogUpdate($filter: EmailLogKeyFilter!, $data: EmailLogUpdateInput!) {
    emailLogUpdate(filter: $filter, data: $data) {
      id
      status
      messageId
    }
  }
`;
